module.exports = __webpack_public_path__ + "img/box7-8-8.8c3c4b25.png";